import React from 'react'
import Data from '../data.json'

export default function Menu() {
    return (
        <div className="page" id="menu">
            <div className="about-intro">
                <h1>CONTACT</h1>
                <a href="mailto:nithins674@gmail.com"><p><span className="fa fa-envelope a-icon"></span>nithins674@gmail.com</p></a>
                <a href={Data.profile.linkedIn} target="_blank" rel="noopener noreferrer"><p><span className="fa fa-linkedin a-icon"></span>linkedin</p></a>
                <a href={Data.profile.github} target="_blank" rel="noopener noreferrer"><p><span className="fa fa-github a-icon"></span>github</p></a>
                <a href={Data.profile.insta} target="_blank" rel="noopener noreferrer"><p><span className="fa fa-instagram a-icon"></span>instagram</p></a>
            </div>
        </div>
    )
}
